export const MAX_DIFF_TIME_MILSEC = 2000;
